const EMAILS = {
	support: 'support@passionapp.co',
}

export default EMAILS
